export { LeaveScreen as default } from '@/src/features/auth/ui/screens/LeaveScreen'
